module.exports = __webpack_public_path__ + "static/media/handQR.c838d083.webp";